import { Injectable, signal } from '@angular/core';
import { from, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PreviewService {
    displaySharing = signal<boolean>(false);
    shareUrl = signal<string | undefined>(undefined);
    shareUid = signal<string | undefined>(undefined);

    constructor() {}

    getPreviewPage(documentId: string): Observable<any> {
        const previewValue = sessionStorage.getItem('preview');
        const ref = previewValue ? { ref: previewValue } : {};
        return from(
            environment.prismic.client.getByID(documentId, {
                ...ref
            })
        );
    }
}
